export default "__VITE_ASSET__55ff15ae__"